import { Button, Menu, MenuItem, useTheme } from '@mui/material';
import { FC, useState } from 'react';
import { Link } from 'react-router-dom';
import MenuItemText from '../MenuItemText';
import { AppMenuItem } from './types';

interface AdminMenuProps {
    userIsAuthenticated: boolean;
    adminMenuItems: AppMenuItem[];
}

/**
 * Admin menu dropdown for authenticated admin users
 */
const AdminMenu: FC<AdminMenuProps> = ({ userIsAuthenticated, adminMenuItems }) => {
    const theme = useTheme();
    const [anchorElAdmin, setAnchorElAdmin] = useState<EventTarget | any>(null);

    const handleOpenAdminMenu = (event: React.SyntheticEvent<EventTarget>) => {
        setAnchorElAdmin(event.currentTarget);
    };

    const handleCloseAdminMenu = () => {
        setAnchorElAdmin(null);
    };

    if (!userIsAuthenticated || adminMenuItems.length === 0) {
        return null;
    }

    return (
        <>
            <Button
                onClick={handleOpenAdminMenu}
                sx={{
                    my: 2,
                    display: 'block',
                    textDecoration: 'none',
                    '&:hover': {
                        textDecoration: 'underline',
                    }
                }}
            >
                <MenuItemText context="appbar">Admin</MenuItemText>
            </Button>
            <Menu
                anchorEl={anchorElAdmin}
                open={Boolean(anchorElAdmin)}
                onClose={handleCloseAdminMenu}
                sx={{
                    '& .MuiPaper-root': {
                        backgroundColor: theme.palette.mode === 'dark' ? '#2d2d2d' : '#999',
                    },
                }}
            >
                {adminMenuItems.map((adminItem) => (
                    <MenuItem
                        key={adminItem.name}
                        onClick={handleCloseAdminMenu}
                        component={Link}
                        to={`${adminItem.link}`}
                    >
                        <MenuItemText context="dropdown">
                            {adminItem.name}
                        </MenuItemText>
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
};

export default AdminMenu;
